/**
 * @module
 * @format
 */

import {localValue} from '@acng/frontend-relativity';
import {ElementLink, ElementSetup} from '@acng/frontend-stargazer';
import {Actor, ctxList} from '../context/list.js';
import {ceil} from '@acng/frontend-bounty/std/number.js';
import {all, find} from '@acng/frontend-bounty/dom/element.js';
import {toggle} from '@acng/frontend-bounty/style/element.js';

ElementSetup('nova-list-pagination', (name) => {
  const provide = Actor();

  ElementLink(name, (element) => {
    const list = localValue(element, ctxList);
    provide(element, async () => [], list.ItemLink);

    (async () => {
      let current = 1;
      const items = await list.more(0);
      const limit = 5;
      const total = items.length;
      const first = 1;
      const last = ceil(total / limit);
      const pagination = find(element, '.pagination');

      if (!pagination) {
        throw Error();
      }

      const buttons = all(pagination, '.ons-item');
      const [prevBtn, firstBtn, , , , center, , , , lastBtn, nextBtn] = buttons;
      prevBtn.onclick = () => goto(current - 1);
      nextBtn.onclick = () => goto(current + 1);
      const setButton = (btn, pageNo) => {
        find(btn, '.label').textContent = `${pageNo}`;
        const box = find(btn, '.box');
        if (box) {
          box.onclick = () => goto(pageNo);
        }
      };

      const setButtons = () => {
        prevBtn.hidden = current <= first;
        nextBtn.hidden = current >= last;
        firstBtn.hidden = current < 4;
        lastBtn.hidden = current > last - 4;
        setButton(firstBtn, first);
        setButton(lastBtn, last);

        for (let i = 2; i < 9; i++) {
          //if (i == 5) continue; center
          const gotoPage = current + (i - 5);
          setButton(buttons[i], gotoPage);
          buttons[i].hidden = gotoPage > last || gotoPage < first;
        }
      };

      setButtons();
      toggle(pagination, 'empty', total <= limit);
      provide(element, async (offset) => (offset ? [] : items.slice(0, limit)), list.ItemLink);

      /**
       * @param {number} pageNo
       */
      const goto = (pageNo) => {
        current = pageNo;
        setButtons();
        element
          .closest('section')
          ?.querySelector('h1')
          ?.scrollIntoView({behavior: 'smooth', block: 'center'});
        provide(
          element,
          async (offset) => {
            if (offset) {
              return [];
            }

            return items.slice((pageNo - 1) * limit, pageNo * limit);
          },
          list.ItemLink,
        );
      };
    })();
  });
});
